
import { mapGetters, mapMutations } from 'vuex'
import Headroom from 'headroom.js'

import btnIcon from '@/components/common/buttons/btn-icon'
import * as shoppingCartLS from '@/lib/shoppingCartLS'

export default {
  name: 'HeaderApp',
  components: {
    btnIcon,
  },
  data() {
    return {
      isLogged: false,
      search: '',
      showSearch: false,
      shoppingCartProductsCount: 0,
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'locale']),
    getClient() {
      return process.client
    },
    navBar() {
      return this.$store.state.layoutData?.content?.navbar.components || []
    },
  },
  mounted() {
    this.isLogged = this.$auth.loggedIn

    this.$bus.$on('reload', () => {
      this.reloadShoppingCartCount()
    })
    this.reloadShoppingCartCount()

    const headerElement = document.getElementById('desktop-header')
    const headroom = new Headroom(headerElement, { offset: 160 })
    headroom.init()
  },
  methods: {
    reloadShoppingCartCount() {
      this.shoppingCartProductsCount = shoppingCartLS.getProductsCount()
    },
    openSearch() {
      this.$store.commit('changeShowSearch', true)
    },
    onOver() {
      this.$refs.dropdown.visible = true
    },
    onLeave() {
      this.$refs.dropdown.visible = false
    },
    ...mapMutations(['changeLocale']),
    changeLang(value) {
      this.$cookies.set('locale', value, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7,
      })
      location.reload()
    },
  },
}
